import { render } from "./HeaderSubmenu.vue?vue&type=template&id=9500c072&scoped=true"
import script from "./HeaderSubmenu.vue?vue&type=script&lang=js"
export * from "./HeaderSubmenu.vue?vue&type=script&lang=js"

import "./HeaderSubmenu.vue?vue&type=style&index=0&id=9500c072&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9500c072"]])

export default __exports__